import { render } from "./UnitInfo_indicators.vue?vue&type=template&id=6f0b64b0"
import script from "./UnitInfo_indicators.vue?vue&type=script&lang=js"
export * from "./UnitInfo_indicators.vue?vue&type=script&lang=js"

import "./UnitInfo_indicators.vue?vue&type=style&index=0&id=6f0b64b0&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__